export default __webpack_public_path__ + "static/media/a012-market-6.3959d0e1.svg";